import React, { useEffect } from 'react'
import { Button, Form } from 'react-bootstrap'
import { Controller } from 'react-hook-form'
import { ModalGenerico } from '../../../../components/ui'
import { ACTIONS } from '../../../../constants'
import { useSelector } from 'react-redux'

export const ModalEnfermedadesTransmicionSexual = ({
  handleSubmit,
  handlerAction,
  action,
  reset,
  control,
  errors,
  setValue
}) => {
  const { activeEts } = useSelector((state) => state.ui)

  useEffect(() => {
    if (activeEts) {
      setValue('nombre', activeEts.nombre)
      setValue('id', activeEts.id)
    }
  }, [activeEts])

  return (
    <ModalGenerico
      title="Enfermedades de transmicion sexual"
      buttonCustom={() => (
        <Button
          variant="primary "
          size="md"
          style={{
            minWidth: '15%'
          }}
          onClick={handleSubmit(handlerAction)}
        >
          {action === ACTIONS.SAVE ? 'Guardar' : 'Actualizar'}
        </Button>
      )}
      closeButtonAction={reset}
    >
      <Form>
        <Form.Group className="mb-2">
          <Form.Label>Nombre de la Enfermedad</Form.Label>
          <Controller
            control={control}
            name="nombre"
            render={({ field }) => (
              <Form.Control type="text" placeholder="Nombre de la Enfermedad..." {...field} />
            )}
          />
          {errors.nombre && (
            <Form.Text className="text-danger">{errors?.nombre?.message}</Form.Text>
          )}
        </Form.Group>
      </Form>
    </ModalGenerico>
  )
}
